import { Box } from '@mui/material';
import img1 from "../../statics/img/01.png";
import img2 from "../../statics/img/02.png";
import img3 from "../../statics/img/03.png";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

/** user homeのスライドショーコンポーネント */
const UHSlides = () => {

    return (
        <Box sx={{ maxWidth: '98vw'}}>
            <Splide
                aria-label="Images"
                options={ {
                    //autoWidth: true,
                    autoplay: true,
                    interval: 5000,
                    rewind: true,
                    width : '100%',
                    gap   : '1rem',
                    lazyLoad: 'nearby',
                    alignItems: 'center',
                    focus    : 'center',
                  } }
            >
                <SplideSlide>
                    <img src={img1} alt="" style={{width: '100%', height: 'auto'}}/>
                </SplideSlide>
                <SplideSlide>
                    <img src={img2} alt="" style={{width: '100%', height: 'auto'}}/>
                </SplideSlide>
                <SplideSlide>
                    <img src={img3} alt="" style={{width: '100%', height: 'auto'}}/>
                </SplideSlide>
            </Splide>
        </Box>

    );
}

export default UHSlides;